import React, { Component } from "react";
import { graphql } from "gatsby";
import { Layout } from "../../components/common";
import { MetaData } from "../../components/common/meta";
import { css } from "@emotion/react";
import WrapHeaderSection from "../../components/common/wrap/WrapHeaderSection";
import WrapSeriesSection from "../../components/common/wrap/WrapSeriesSection";
import WrapNoissueTV from "../../components/common/wrap/WrapNoissueTV";
import WrapNoissue101 from "../../components/common/wrap/WrapNoissue101";
import WrapBizAdvice from "../../components/common/wrap/WrapBizAdvice";
import WrapCommunitySection from "../../components/common/wrap/WrapCommunitySection";
import WrapNewsLetter from "../../components/common/wrap/WrapNewLetter";
import WrapInspoSection from "../../components/common/wrap/WrapInspoSection";

class Page extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, location } = this.props;
        const allData = data.allGhostPost.edges;
        const videoNodes = data.videoNodes.nodes;
        return (
            <>
                <MetaData data={data} location={location} type="website" />
                <Layout bodyClass={`page thewrap elbrus-headless`}>
                    <WrapHeaderSection/>
                    <WrapSeriesSection />
                    <WrapNoissueTV data={videoNodes}/>
                    <WrapInspoSection data={allData}/>
                    <WrapNoissue101 data={allData}/>
                    <WrapBizAdvice data={allData}/>
                    <WrapCommunitySection />
                    <WrapNewsLetter/>
                </Layout>
            </>
        );
    }
}

export default Page;

export const postQuery = graphql`
    query {
        ghostPage(slug: { eq: "wrap" }) {
            ...GhostPageFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            limit: 200
            skip: 0
        ) {
            edges {
                node {
                    ...GhostPostFields
                }
            }
        }
        videoNodes: allContentfulVideo(
            sort: { fields: originalPublishedDate, order: DESC }
            filter: { node_locale: { eq: "en-US" } }
            limit: 200
            skip: 0
        ) {
            nodes {
                id
                slug
                title
                url
                postSlug
                excerpt {
                    excerpt
                }
                originalPublishedDate
                createdAt
                display_created_at: createdAt(formatString: "DD MMMM, YYYY")
                type {
                    id: contentful_id
                }
                channel {
                    slug
                    name
                }
                community {
                    id: contentful_id
                }
            }
        }
    }
`;
